import { unifiedApiKeys } from '@/services/keys';
import type { ClientId } from '@/types/api';
import { UnifiedApiParams } from '@/types/mercury-data-types/unifiedapi';

export const SERVICEREQUESTS_ENDPOINTS = {
  rfi: '/issue/rfis',
  takedowns: '/issue/takedowns',
} as const;

export const rfiKeys = {
  all: ['rfi'] as const,

  table: (params?: Partial<UnifiedApiParams>) =>
    ['table', ...unifiedApiKeys.records(SERVICEREQUESTS_ENDPOINTS.rfi, params)] as const,

  gfx: (clientId?: ClientId) =>
    clientId !== undefined ? (['rfi', 'gfx', clientId] as const) : (['rfi', 'gfx'] as const),

  dashboard: (params?: Partial<UnifiedApiParams>) =>
    ['dashboard', unifiedApiKeys.records(SERVICEREQUESTS_ENDPOINTS.rfi, params)] as const,
};

export const takedownKeys = {
  all: ['sr-takedowns'] as const,

  table: (params?: Partial<UnifiedApiParams>) =>
    ['table', ...unifiedApiKeys.records(SERVICEREQUESTS_ENDPOINTS.takedowns, params)] as const,
};
